import type { Idea } from '@thinkalpha/platform-ws-client/contracts/ideas/index.js';
import type { IdeaStage as IdeaStageContract } from '@thinkalpha/platform-ws-client/contracts/table.js';
import type { IdeaDTO } from 'src/dtos/Idea';
import { UniversePlanDTO } from 'src/features/universe/dtos/UniversePlanDTO';
import { IdeaStage, SourceStage } from 'src/lib/tableStages';
import type { Stage } from 'src/lib/tableStages';

type IdeaStageOptions = Omit<IdeaStageContract, 'type' | 'inputStage' | 'idea'>;

export function ideaDTOToInlineIdea(dto: IdeaDTO): Idea {
    return {
        ...dto.idea,
        key: dto.idea.key ?? 'ticker',
        plan: dto.plan.toContract(),
    };
}

export function ideaDTOToStage(inputStage: Stage, dto: IdeaDTO, options: IdeaStageOptions = {}): Stage {
    if (dto.plan instanceof UniversePlanDTO) {
        return SourceStage.fromTickerUniverseId(dto.plan.universeId);
    }

    return IdeaStage.fromInputStage(inputStage, ideaDTOToInlineIdea(dto), options);
}
